/**
 *   混入的对象中的data属性，和组件的data属性冲突，以组件的值优先。组件中没有的属性，混入对象中的生效。
 *   同名钩子函数将会合并成一个数组，都会调用，混入函数先调用
 *   值为对象的选项，如methods，components，directives等，将会合并为一个新对象，如果键名冲突，组件的值优先
 */
export default {
   data(){
        return {
            currentModuleCode: '',
            isLapTop: false,
            isMediumPc: false,
            isShieldSelectionIndex: false, // 职能目标屏蔽选择指标
        }
   },
   //过滤器
   filters: {},
   //钩子函数 生命周期 - 创建完成（访问当前this实例）
   created(){
       
   },
   //计算属性
   computed: {},
   // 方法
   methods:{
        mixinYearList(num) {
            num ? num : num = 1
            let nowYear = new Date().getFullYear()
            let arr = []
            for (let i = 2022; i <= nowYear + num; i++) {
                let item = {
                    title: i,
                    label: i,
                    value: i
                }
                arr.push(item)
            }
            return arr
        },
        fillLanguage(target, keys){
            if(keys.length != 3) {
                return console.error("error keys Array");
            }
            const copyData = this.$lodash.cloneDeep(target);
            // 如果存在 简体中文 在没有繁体和英文的情况下 就填充
            //找到优先级第一的
            let existValue = ''
            keys.forEach(key => {
                if(!existValue && copyData[key]) {
                    existValue = copyData[key];
                }
            })
            keys.forEach(key => {
                if(existValue && !copyData[key]){
                    copyData[key] = existValue;
                }
            })
            return copyData;
        },
        getOptionsDesc(data, value) {
            let target = '';
            if(data.length && value) {
                target = data.find(option => {
                    return option.value === value;
                })
                return target && target.label;
            } else {
                return ''
            }
        },
       /**
        * 这个方法是限制table表格得值只能输入[0-100]得整数或者【0-100】的至多两位小数
        * @param row
        * @param key
        */
        setNumber(row, key) {
            if(row[key] && row[key].replace){
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key] ? row[key].replace(/[^0-9.]/g, "") : row[key];
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key].replace(/[^\d.]/g,"");
                //必须保证第一个为数字而不是.
                row[key] = row[key].replace(/^\./g,"");
                //保证只有出现一个.而没有多个.
                row[key] = row[key].replace(/\.{2,}/g,".");
                //保证.只出现一次，而不能出现两次以上
                row[key] = row[key].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                // 保证小数点后只有两位小数
                row[key] = row[key].replace(/\.[0-9]{3,}/g,row[key].substr(row[key].lastIndexOf("."),3));
                // 小于等于100；
                row[key]=row[key]>100?((row[key]+'').substr(0,3) === '100'?'100':(row[key]+'').substr(0,2)):row[key];
                // 如果第一位数为0，后面不能输入数字，除了.
                row[key] = row[key].replace(/^0[0-9]/g,"0");
            }
        },
        setFloatNumberFixed2(row,key) {
            if(row[key] && row[key].replace){
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key] ? row[key].replace(/[^0-9.]/g, "") : row[key];
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key].replace(/[^\d.]/g,"");
                //必须保证第一个为数字而不是.
                row[key] = row[key].replace(/^\./g,"");
                //保证只有出现一个.而没有多个.
                row[key] = row[key].replace(/\.{2,}/g,".");
                //保证.只出现一次，而不能出现两次以上
                row[key] = row[key].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                // 保证小数点后只有两位小数
                row[key] = row[key].replace(/\.[0-9]{3,}/g,row[key].substr(row[key].lastIndexOf("."),3));
                // 小于等于100；
                row[key] = row[key].replace(/^0[0-9]/g,"0");
            }
        },
        setFloatNumber(row,key,type=0) {
            if(type){
                
                //先把非数字的都替换掉，除了数字和.
                // row[key] = row[key] ? row[key].replace(/[^0-9.]/g, "") : row[key];
                // row[key] = row[key] ? row[key].replace(/^(\-|\+)?\d+(\.\d+)?$/, ''): row[key]
                row[key] = row[key] ? row[key].replace(/[^0-9.-]/g, "") : row[key];
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key].replace(/[^-?\d.\d]/g,"");
                // //必须保证第一个为数字而不是.
                row[key] = row[key].replace(/^\./g,"");
                // //保证只有出现一个.而没有多个.
                row[key] = row[key].replace(/\.{2,}/g,".");
                row[key] = row[key].replace(/\-{2,}/g, "-") //出现多个负号时只保留第一个
                // //保证.只出现一次，而不能出现两次以上
                row[key] = row[key].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                row[key] = row[key].replace("-","$#$").replace(/\-/g,"").replace("$#$","-");
                // if(mark){
                //     row[key]=0-row[key]
                // }
                //终极判断
                // row[key] = row[key] != eval(row[key]) ? 0: eval(row[key]);
                // // 小于等于100；
                // row[key] = row[key].replace(/^0[0-9]/g,"0");
            
            }else if(row[key] && row[key].replace){
                //先把非数字的都替换掉，除了数字和.
                // row[key] = row[key] ? row[key].replace(/[^0-9.]/g, "") : row[key];
                // row[key] = row[key] ? row[key].replace(/^(\-|\+)?\d+(\.\d+)?$/, ''): row[key]
                row[key] = row[key] ? row[key].replace(/[^0-9.-]/g, "") : row[key];
                //先把非数字的都替换掉，除了数字和.
                row[key] = row[key].replace(/[^\d.\d]/g,"");
                // //必须保证第一个为数字而不是.
                row[key] = row[key].replace(/^\./g,"");
                // //保证只有出现一个.而没有多个.
                row[key] = row[key].replace(/\.{2,}/g,".");
                // //保证.只出现一次，而不能出现两次以上
                row[key] = row[key].replace(".","$#$").replace(/\./g,"").replace("$#$",".");
                //终极判断
                // row[key] = row[key] != eval(row[key]) ? 0: eval(row[key]);
                // // 小于等于100；
                // row[key] = row[key].replace(/^0[0-9]/g,"0");
            }
        },
        toFixed(num, s) {
            let times = Math.pow(10, s)
            let des = num * times + 0.5
            des = parseInt(des, 10) / times
            return des + ''
        },
        onResize(){
            this.isLapTop = window.innerWidth < 1600 ? true: false;
            this.isMediumPc = window.innerWidth < 1920 && window.innerWidth >= 1600 ? true: false;
        }
   },
   mounted() {
    this.onResize();
    window.addEventListener('resize', this.onResize);
   },
   destroyed() {
    window.removeEventListener('resize', this.onResize);
   },
}